import { withInstall } from '@bigin/utils'
import TagInput from './src/tag-input.vue'

export const BTagInput = withInstall(TagInput)
export default BTagInput

export * from './src/tag-input'
